module.exports = __webpack_public_path__ + "static/img/gongsi_banner.48e2b5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introdution/gongsi_banner.png
// module id = efKV
// module chunks = 1